import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

export default function About({ data }) {
  const features = (data?.features || []).filter((f) => f.enabled !== false);

  return (
    <section id="about" data-testid="about-section" className="relative py-24 sm:py-32 px-6 bg-[#FBF8F1]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-6 relative"
        >
          <div className="relative rounded-3xl overflow-hidden border border-[#EFEAD8] shadow-[0_30px_80px_-20px_rgba(212,175,55,0.25)]">
            {data?.image && (
              <img src={data.image} alt="M&C Clean Fresh team at work" className="w-full h-[480px] sm:h-[560px] object-cover" />
            )}
          </div>
          {data?.stat_value && (
            <div className="absolute -bottom-6 -right-2 sm:-right-6 bg-white border border-[#D4AF37]/30 rounded-2xl p-5 shadow-[0_18px_40px_-18px_rgba(212,175,55,0.4)] hidden sm:block">
              <div className="text-3xl font-display font-bold text-gradient-gold">{data.stat_value}</div>
              <div className="text-xs uppercase tracking-wider text-gray-600 mt-1">{data.stat_label}</div>
            </div>
          )}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-6"
        >
          {data?.eyebrow && (
            <p className="text-[11px] uppercase tracking-[0.32em] text-[#B8941F] font-semibold mb-4">{data.eyebrow}</p>
          )}
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A0A0A] leading-[1.1]">
            {data?.title_1} {data?.title_accent && <span className="text-gradient-gold">{data.title_accent}</span>}
          </h2>
          {data?.description && (
            <p className="mt-6 text-gray-600 text-base sm:text-lg leading-relaxed max-w-xl">{data.description}</p>
          )}
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {features.map((f, i) => (
              <motion.div
                key={f.id || f.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white border border-[#EFEAD8] hover:border-[#D4AF37]/50 transition-colors"
                data-testid={`about-feature-${i}`}
              >
                <span className="w-7 h-7 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center shrink-0">
                  <Check className="w-3.5 h-3.5 text-[#B8941F]" strokeWidth={3} />
                </span>
                <span className="text-sm sm:text-[15px] text-gray-800 font-medium">{f.label}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
